import React from 'react';
import { LoadingContainer, LoadingWrapper } from './styles/Loading.styled';

export default function Loading() {
  return (
    <LoadingWrapper>
      <LoadingContainer className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </LoadingContainer>
    </LoadingWrapper>
  );
}
